import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { REGION } from '@ms/config/app'

Vue.use(VueI18n)

const locale = REGION
console.log('locale', locale)

const COUNTRY_CONFIG = require(`./lib/${REGION}.json`)

const i18n = new VueI18n({
  messages: {
    [locale]: {
      ...COUNTRY_CONFIG,
      URL_FLAG: require(`public/images/flags/${COUNTRY_CONFIG.COUNTRY}.png`)
    }
  },
  locale
})

const loadedLanguages = [locale] // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang
  return lang
}

export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `./lib/${lang}.json`).then((messages) => {
    i18n.setLocaleMessage(lang, {
      ...messages.default,
      URL_FLAG: require(`public/images/flags/${messages.default.COUNTRY}.png`)
    })
    loadedLanguages.push(lang)
    return setI18nLanguage(lang)
  })
}

export default i18n
